import React, { useEffect, useRef, useState } from 'react';
import './cohort-view-mc-list.styles.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';

const CohortViewMcList = ({
    cohort,
    userList,
    mcList,
    progressNumbers
}) => {

    const [ compiledMcs, setCompiledMcs ] = useState(null);
    const timeoutRef = useRef();
    const navigate = useNavigate();

    useEffect(() => {
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
    }, [])

    useEffect(() => {
        if (!userList || !mcList || !progressNumbers) return;
        compileMcData();
    }, [userList, mcList, progressNumbers])

    useEffect(() => {
        if (!compiledMcs) return;
        timeoutRef.current = setTimeout(() => {
            for (let mc of Object.values(compiledMcs)) {
                document.getElementById(`progress-${mc.mc_key}`).style.width = mc.pct + "%";
            }
        }, 500);
    }, [compiledMcs])
    
    function compileMcData() {
        let compiledData = {};
        let totalUsers = Object.values(userList).length;
        for (let mc of Object.values(mcList)) {
            let completeCount = 0;
            let mcProg = progressNumbers[mc.mc_key];
            if (mcProg) {
                for (let cst_key of Object.keys(mcProg)) {
                    if (!userList[cst_key]) continue;
                    let userProg = mcProg[cst_key];
                    if (!userProg) continue;
                    let progNum = userProg.progNum;
                    if (progNum >= 9) completeCount++;
                }
            }
            compiledData[mc.mc_key] = {
                'name': mc.name,
                'mc_key': mc.mc_key,
                'imageUrl': mc.imageUrl,
                'complete': completeCount,
                'total': totalUsers,
                'pct': ((completeCount/totalUsers) * 100).toFixed(0).toLocaleString(),
            }
        }
        setCompiledMcs(compiledData);
    }

    return (
        <div className='cohort-view-mc-list'>
            {
                (compiledMcs) &&
                Object.values(compiledMcs)
                .sort((a, b) => a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1)
                .map(mc => {

                    return (
                        <div key={mc.mc_key} className='cohort-view-mc-item'>
                            <div className='mc-icon'>
                                <img src={mc.imageUrl} className='mc-icon' />
                            </div>
                            <div className='mc-name'>
                                {mc.name}
                            </div>
                            <div className='progress-container'>
                                <div className="progress">
                                    <div 
                                        className="progress-bar"
                                        id={`progress-${mc.mc_key}`} 
                                        aria-valuenow={mc.pct} 
                                        min="0" 
                                        max="100" >
                                    </div>
                                </div>
                                <div className='meta'>{mc.complete}/{mc.total} Complete</div>
                                
                            </div>
                            <div className='buttons'>
                                <button 
                                    className='g-button small-btn'
                                    onClick={() => navigate(`mc/${mc.mc_key}`)}>
                                    <FontAwesomeIcon icon={faMagnifyingGlass} />
                                </button>
                            </div>
                        </div>
                    )
                })
            }
        </div>
    )
}

export default CohortViewMcList